<div fxLayout="row" fxLayoutAlign="start center">
  <button (click)="open()" mat-icon-button>
    <mat-icon [icIcon]="icSearch"></mat-icon>
  </button>
  <mat-form-field [class.search-open]="isOpen" appearance="outline" class="search" fxFlex="auto">
    <mat-label>Search&hellip;</mat-label>
    <input #input (blur)="close()" matInput>
  </mat-form-field>
</div>
